// Externals
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { navigate, useBasePath } from "raviger";
import FetchResults from "../utils/fetchResults";
import Lottie from "react-lottie-player";

// Components
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Floor from "../components/Floor/Floor";

// Animation Data
import animationData from "../static/lottie/Dog_Loading.json";

// Styles
import "./WaitScreen.scss";
import { updateMathces } from "../store/actions/matches";

const Waitscreen = (props /*: Props */) /*: React.Component */ => {
	const [loaded, setLoaded] = useState(false);
	const [isNSW, setIsNSW] = useState(false);
	const [isNotAus, setIsNotAus] = useState(false);
	const [results, setResults] = useState([]);
	const basepath = useBasePath();

	const userName = useSelector((state) => state.answers[1].answer[0].text);
	const userAge = useSelector((state) => state.answers.age);
	const userPostcode = useSelector((state) => state.answers.postcode);
	const userEmail = useSelector((state) => state.answers.email);

	const answerQ2 = useSelector((state) => state.answers[2].answer[0].id);
	const answerQ3 = useSelector((state) => state.answers[3].answer[0].id);
	const answerQ4 = useSelector((state) => state.answers[4].answer[0].id);
	const answerQ5 = useSelector((state) => state.answers[5].answer[0].id);
	const answerQ6 = useSelector((state) => state.answers[6].answer[0].id);
	const answerQ7 = useSelector((state) => typeof state.answers[7].answer[0] !== 'undefined' ? state.answers[7].answer[0].id : null);

	const answerQ9 = useSelector((state) => state.answers[9].answer[0].id);
	const answerQ10 = useSelector((state) => state.answers[10].answer[0].id);
	const answerQ11 = useSelector((state) => state.answers[11].answer[0].id);
	// const answerQ12 = useSelector((state) => state.answers[12].answer[0].id);
	const answerQ13 = useSelector((state) => state.answers[13].answer[0].id);
	const answerQ14 = useSelector((state) => state.answers[14].answer[0].id);
	const answerQ15 = useSelector((state) => state.answers[15].answer[0].id);
	const answerQ16 = useSelector((state) => state.answers[16].answer[0].id);
	const answerQ17 = useSelector((state) => state.answers[17].answer[0].id);
	const answerQ18 = useSelector((state) => state.answers[18].answer[0].id);

	const answerQ8 = useSelector((state) => state.answers[8]);

	var formdata = new FormData();

	formdata.append("name", userName);
	formdata.append("age", userAge);
	formdata.append("email", userEmail);
	formdata.append("postcode", userPostcode);
	formdata.append("question_2", answerQ2);
	formdata.append("question_3", answerQ3);
	formdata.append("question_4", answerQ4);
	formdata.append("question_5", answerQ5);
	formdata.append("question_6", answerQ6);
	formdata.append("question_7", answerQ7);
	answerQ8?.answer.forEach((item) =>
		formdata.append("question_8[]", item.id),
	);
	formdata.append("question_9", answerQ9);
	formdata.append("question_10", answerQ10);
	formdata.append("question_11", answerQ11);
	// formdata.append("question_12", "42");  // Not used?
	formdata.append("question_13", answerQ13);
	formdata.append("question_14", answerQ14);
	formdata.append("question_15", answerQ15);
	formdata.append("question_16", answerQ16);
	formdata.append("question_17", answerQ17);
	formdata.append("question_18", answerQ18);
	formdata.append("password_protected_pwd", "wGB3k&f>pe");

	const dispatch = useDispatch();

	useEffect(() => {
		let mounted = true;

		FetchResults(formdata).then((data) => {
			if (mounted) {
				setResults(data);
				dispatch(updateMathces({ matches: data }));
				setLoaded(true);
			}
		});
		return () => (mounted = false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		loaded && !results.length && navigate(`${basepath}/results`);
		loaded && userAge < 18 && navigate(`${basepath}/results`);
		loaded && !isNSW && navigate(`${basepath}/results`);
		loaded && isNotAus && navigate(`${basepath}/results`);
		loaded && results.length && navigate(`${basepath}/matches`);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [results, loaded]);

	function inRange(x, min, max) {
		return (x - min) * (x - max) <= 0;
	}

	// NSW postcode range src https://auspost.com.au/business/marketing-and-communications/access-data-and-insights/address-data/postcode-data
	// 1000-2599
	// 2620 - 2899
	// 2921 - 2999

	useEffect(() => {
		if (userPostcode) {
			if (
				inRange(userPostcode, 1000, 2599) ||
				inRange(userPostcode, 2620, 2899) ||
				inRange(userPostcode, 2921, 2999)
			) {
				setIsNSW(true);
			} else {
				setIsNSW(false);
			}
		} else {
			setIsNotAus(true);
		}
	}, [userPostcode]);

	return (
		<div className="waitscreen">
			<Header />
			<Header2 />
			<div className="waitscreen-content-desktop">
				{!loaded && (
					<div className="animation">
						<Lottie
							className="lottie-container basic"
							animationData={animationData}
							play={true}
							loop={true}
							speed={2}
						/>
					</div>
				)}
				<Floor id={5} />
			</div>
		</div>
	);
};

// Exports
export default Waitscreen;
